import Payment from 'payment';

/** gets issuer from card number */
function getIssuer(value: unknown) {
	if (typeof value !== 'string') {
		return null;
	}

	return Payment.fns.cardType(value);
}

export default getIssuer;
